import { defineVuexModule } from '../helpers';

export default defineVuexModule({
  namespaced: true,
  state: {
    // rowSeats: 0,
    gaCount: 0,
    gaSeats: 0,
    tablesCount: 0,
    tableSeats: 0,
    unlabeledSeats: 0,
    conflictedSeats: 0,
    blockedSeats: 0,
    blockedGa: 0,
    invisibleSeats: 0,
    disabledSeats: 0,
    rowSeatsCount: 0,
  },

  getters: {
    rowSeats: (state) => state.rowSeatsCount - state.invisibleSeats,
    totalSeats: (state, getters) => getters.rowSeats + state.tableSeats + state.gaSeats,
    labeledSeats: (state, getters) => state.tableSeats + getters.rowSeats - state.unlabeledSeats,
  },

  actions: {
    changeTablesCount(context, value) {
      context.commit('tablesCount', value);
    },
    changeGACount(context, value) {
      context.commit('gaCount', value);
    },
    changeRowSeats(context, value) {
      context.commit('rowSeats', value);
    },
    changeTableSeats(context, value) {
      context.commit('tableSeats', value);
    },
    changeGASeats(context, value) {
      context.commit('gaSeats', value);
    },
    changeConflictedSeats(context, value) {
      context.commit('conflictedSeats', value);
    },
    changeUnlabeledSeats(context, value) {
      context.commit('unlabeledSeats', value);
    },
    changeInvisibleSeats(context, value) {
      context.commit('invisibleSeats', value);
    },
    changeDisabledSeats(context, value) {
      context.commit('disabledSeats', value);
    },
    changeBlockedSeats(context, value) {
      context.commit('blockedSeats', value);
    },
    changeBlockedGa(context, value) {
      context.commit('blockedGa', value);
    },
  },

  mutations: {
    rowSeats(state, value) {
      state.rowSeatsCount = value;
    },
    tableSeats(state, value) {
      state.tableSeats = value;
    },
    gaSeats(state, value) {
      state.gaSeats = value;
    },
    tablesCount(state, value) {
      state.tablesCount = value;
    },
    gaCount(state, value) {
      state.gaCount = value;
    },
    conflictedSeats(state, value) {
      state.conflictedSeats = value;
    },
    unlabeledSeats(state, value) {
      state.unlabeledSeats = value;
    },
    invisibleSeats(state, value) {
      state.invisibleSeats = value;
    },
    disabledSeats(state, value) {
      state.disabledSeats = value;
    },
    blockedSeats(state, value) {
      state.blockedSeats = value;
    },
    blockedGa(state, value) {
      state.blockedGa = value;
    },
  },
});
